/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser {
    onCreateUser {
      id
      firstName
      lastName
      email
      avatar
      company
      title
      country
      lastLogin
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser {
    onUpdateUser {
      id
      firstName
      lastName
      email
      avatar
      company
      title
      country
      lastLogin
      createdAt
      updatedAt
    }
  }
`;
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification {
    onCreateNotification {
      id
      type
      body
      button
      link
      createdAt
      updatedAt
    }
  }
`;
export const onCreateEventConfig = /* GraphQL */ `
  subscription OnCreateEventConfig {
    onCreateEventConfig {
      id
      stage
      streamStartTime
      useBackupStream
      environment
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateEventConfig = /* GraphQL */ `
  subscription OnUpdateEventConfig {
    onUpdateEventConfig {
      id
      stage
      streamStartTime
      useBackupStream
      environment
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteEventConfig = /* GraphQL */ `
  subscription OnDeleteEventConfig {
    onDeleteEventConfig {
      id
      stage
      streamStartTime
      useBackupStream
      environment
      createdAt
      updatedAt
    }
  }
`;
